
import { Component, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectorRef, OnChanges } from '@angular/core';
import { MediaService } from 'src/app/shared/services/mediaservice/media.service';
import { AddService } from 'src/app/shared/services/userservices/add.service';
@Component({
  selector: 'app-user-detail-info',
  templateUrl: './user-detail-info.component.html',
  styleUrls: ['./user-detail-info.component.css'],
  standalone: true,
  imports: [FormsModule, RouterModule, DatePipe, CommonModule],

})
export class UserDetailInfoComponent implements OnChanges {
  @Output() loadingChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() profileUpdated: EventEmitter<void> = new EventEmitter<void>();
  @Input() userData: any;
   @Input() isLoading = false;
   @Input() actionView = false;
   public showSpinner = false;
  mapUrl: SafeResourceUrl | undefined;
  role_type: any;
  formData: any;
  imagePath: any;
  constructor(
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private addService: AddService,

    private mediaService: MediaService,
  ) { }
  ngOnChanges(changes: SimpleChanges) {
      if (changes['isLoading']) {
      // force Angular to check and update the view
      this.cdr.detectChanges();
    }
     if (changes['isLoading']) {
        console.log('asdas isLoading changed:', changes['isLoading'].currentValue);
      }
    if (changes['userData'] && changes['userData'].currentValue) {
      const rawRoles = this.userData.user_roles;

      let userRoles: any = {};
      try {
        if (rawRoles) {
          // If it's a string, parse it. If it's already an object, use as-is.
          userRoles = typeof rawRoles === 'string' ? JSON.parse(rawRoles) : rawRoles;
        }
      } catch (err) {
        console.error('Failed to parse user_roles:', rawRoles, err);
        userRoles = {};
      }

      this.role_type = userRoles?.role_type ?? 'Employee';

      if (this.role_type === 'Admin_AND_Team_Lead') {
        this.role_type = 'TL Admin';
      } else if (this.role_type === 'Team_Lead') {
        this.role_type = 'Team Lead';
      } else if (this.role_type === 'Admin') {
        this.role_type = 'Admin';
      } else {
        this.role_type = 'Employee';
      }
      this.getLatLongAndMap(this.userData.address);
    }
  }
  getLatLongAndMap(addressObj: any) {
    if (!addressObj) return;

   const address_lat = addressObj?.address_lat ?? 31.4712997;
   const address_lng = addressObj?.address_lng ?? 74.3068964;

  

      this.mapUrl = this.getStaticMap(address_lat, address_lng);
    
  }

  getStaticMap(lat: number, lng: number): SafeResourceUrl {
    const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=15&size=550x250&markers=color:red|${lat},${lng}&key=${environment.GoogleMapKey}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(mapUrl);
  }




  selectedFile!: File; // store selected file

// When user selects an image
onFileSelected(event: Event) {
  const input = event.target as HTMLInputElement;
  if (!input.files?.length) return;

  this.selectedFile = input.files[0]; // store the file for upload

  // Preview the image immediately
  const reader = new FileReader();
  reader.onload = () => {
    this.userData.profile_image = reader.result as string;
  };
  reader.readAsDataURL(this.selectedFile);
  this.uploadProfileImage(this.selectedFile);
}

// Upload the selected image
uploadProfileImage(data: any) {
    this.loadingChange.emit(true);
  if (!data) {
    console.error('No file selected for upload');
    return;
  }

  const formData = new FormData();
  formData.append('file', data); // append the selected file

  this.mediaService.uploadImage(formData).subscribe(
    (response: any) => {
      this.imagePath = response.data.path; // store uploaded image path
      this.updateUserImg(this.imagePath);
      console.log('Image uploaded successfully:', this.imagePath);
    },
    (error) => {
      console.error('Image upload failed:', error);
    }
  );
}


updateUserImg(data: any) {
   
    const Profile_img = data;
    this.addService.updateUserImage(Profile_img).then((value) => {
      this.profileUpdated.emit();
    });
  }










}
